// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import DisplayLayout from '@/layout/DisplayLayout';
import { RouteConfig } from 'react-router-config';
import Document from './view/home';
import Editor from './view/editor/index';
import Demo from './view/demo';
import Preview from './view/preview';

const routes: RouteConfig[] = [
  {
    component: DisplayLayout,
    path: '/',
    routes: [
      {
        path: '/index',
        exact: true,
        component: Document,
      },
      {
        path: '/preview',
        exact: true,
        component: Preview, // 预览页面路由
      },
      {
        path: '/editor',
        exact: true,
        component: Editor,
      },
      {
        path: '/demo',
        exact: true,
        component: Demo,
      },
      {
        path: '*',
        component: Document,
      },
    ],
  },
];

export default routes;
